import { render, staticRenderFns } from "./HoldingsFilters.vue?vue&type=template&id=1c0797f8&"
import script from "./HoldingsFilters.vue?vue&type=script&lang=js&"
export * from "./HoldingsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports